import {ReactWebComponentDescription} from "@infonova/framework/lib/webcomponents/ReactWebComponentDescription";
import {FunctionComponent} from "react";
import {registerAsWebComponent} from "@infonova/framework/lib/webcomponents/registerAsWebComponent";
import {JssWrapper} from "./JssWrapper";

// @ts-ignore
import css from "../../../sass/style.scss";

const internalCss = new CSSStyleSheet();
function updateCss() {
    // @ts-ignore
    internalCss.replaceSync(css);
}

updateCss();
// @ts-ignore
if (module.hot) {
    // @ts-ignore
    module.hot.accept('../../../sass/style.scss', () => {
        updateCss();
    });
}

export function registerAsIntegrationWebComponent<P>(descriptionOrName: ReactWebComponentDescription<P>, component: FunctionComponent<P>): void {
    descriptionOrName.css = internalCss;
    registerAsWebComponent(descriptionOrName, JssWrapper(component));
}